'use client';

import { siteThumbnailUrl } from '@/constants/shareLink';

import { ShareModalClient } from './ShareModalClient';

interface WorkbenchShareModalProps {
  shareUrl: string | null;
  metaSiteId?: string;
  targetUrl?: string;
  onClose: () => void;
}

export function WorkbenchShareModal({
  shareUrl,
  metaSiteId,
  targetUrl,
  onClose,
}: WorkbenchShareModalProps) {
  const imageUrl = metaSiteId ? siteThumbnailUrl(metaSiteId) : undefined;

  return (
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="absolute inset-0 bg-black/40"
        aria-hidden="true"
        onClick={onClose}
      />
      <div className="relative z-10 mx-4">
        <ShareModalClient
          shareUrl={shareUrl}
          siteUrl={targetUrl}
          imageUrl={imageUrl}
          commentsCount={0}
          unreadCount={0}
          onClose={onClose}
          showFootnote={false}
        />
      </div>
    </div>
  );
}
